import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
	DocumentTemplate as objectPayload,
	DocumentTemplateAddPayload as objectAddPayload,
	DocumentTemplateEditPayload as objectEditPayload,
	DocumentTemplateForm as objectForm,
} from './document-template.interface';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentTemplateService {
  private serviceName = 'DocumentTemplateService';

  private token!: string;
  private basePath = environment.interop.basePath;

  public getListDTUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.listDT;

  private getListUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.list;

  private oneUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.one;

  private templateById =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.templateById;

  private updateUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.update;

  private storeUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.store;

  private deleteUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.delete;

  private functiiUserUrl =
    this.basePath + environment.interop.urbanism.nomenclatoare.functiiUser.list;

  private functiiUserActiveUrl =
    this.basePath + environment.interop.urbanism.nomenclatoare.functiiUser.list;

  private signaturesTemplateOperatorListIdsUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.signatures
      .getListIds;

  private updateSignaturesTemplateOperatorIdsUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.signatures
      .updateIds;

  private updateOrderUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.signatures
      .updateOrder;

  private updateSignTypeUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.signatures
      .updateSignType;

  private updateSignaturesUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.documentTemplate.signatures
      .updateSignatures;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.urbanism.nomenclatoare.documentTemplate.changeActive;

  // because cereri, we need to add special routes

  private getListIdsSignaturesDocumentGeneratUrl =
    this.basePath + environment.interop.urbanism.cerere.signatures.getListIds;

  private updateListIdsSignaturesDocumentGeneratUrl =
    this.basePath + environment.interop.urbanism.cerere.signatures.updateIds;

  private updateSignaturesDocumentGeneratUrl =
    this.basePath +
    environment.interop.urbanism.cerere.signatures.updateSignatures;

  private httpOptions: any;

  constructor(private http: HttpClient) {}

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }

  update(data: objectEditPayload) {
    return this.http.put(this.updateUrl, data, this.httpOptions);
  }

  store(data: objectAddPayload) {
    return this.http.post(this.storeUrl, data, this.httpOptions);
  }

  delete(id: number) {
    return this.http.delete(this.deleteUrl + id);
  }

  one(id: number) {
    return this.http.get(this.oneUrl + id, this.httpOptions);
  }

  templateByCerereId(id: number, cerere_id: number) {
    return this.http.get(
      this.templateById + id + '/' + cerere_id,
      this.httpOptions
    );
  }

  getRecordsList(is_address: boolean) {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getListUrl + '?' + 'is_address=' + is_address
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error(
            'Error in get request with service ' + this.serviceName,
            error
          );
          return throwError(error);
        })
      );
  }

  getFunctiiUserActiveList() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.functiiUserActiveUrl
      )
      .pipe(
        map((response) => {
          console.log(response);
          return response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        }),
        catchError((error) => {
          console.error(
            'Error in get request with service ' + this.serviceName,
            error
          );
          return throwError(error);
        })
      );
  }

  getFunctiiUserList() {
    return this.http.get(this.functiiUserActiveUrl, this.httpOptions);
  }

  signaturesTemplateOperatorListIds(
    id: number,
    docType: number | undefined,
    manualOverride: boolean = false
  ) {
    // return is simple, [1,2,3]

    let pathUrl =
      manualOverride == false
        ? this.signaturesTemplateOperatorListIdsUrl
        : this.getListIdsSignaturesDocumentGeneratUrl;

    return this.http.get(pathUrl + id + '/' + docType, this.httpOptions);
  }

  updateSignaturesTemplateOperatorIds(
    id: number,
    data: any,
    manualOverride: boolean = false
  ) {
    // basically a simple array with numbers [1,2,3]

    let pathUrl =
      manualOverride == false
        ? this.updateSignaturesTemplateOperatorIdsUrl
        : this.updateListIdsSignaturesDocumentGeneratUrl;

    return this.http.put(pathUrl + id, data, this.httpOptions);
  }

  updateOrder(id: number, data: any) {
    // basically a simple array with numbers [1,2,3]
    return this.http.post(this.updateOrderUrl + id, data, this.httpOptions);
  }

  updateSignType(id: number, data: any) {
    return this.http.post(this.updateSignTypeUrl + id, data, this.httpOptions);
  }

  updateSignatures(data: any, manualOverride: boolean = false) {
    let pathUrl =
      manualOverride == false
        ? this.updateSignaturesUrl
        : this.updateSignaturesDocumentGeneratUrl;
    return this.http.post(pathUrl, data, this.httpOptions);
  }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }
}
